import { useEffect, useState } from 'react';
import api, { mediaUrl } from '../../lib/api';
import { flattenSponsorGroups } from '../../lib/sponsors';
import { useSettings } from '../../context/SettingsContext';
import { toast } from 'sonner';

const LogoMarquee = () => {
  const { modules } = useSettings();
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    api.get('/sponsors').then((r) => {
      const all = flattenSponsorGroups(r.data).filter((s) => s.logo_url || s.logo);
      setSponsors(all);
    }).catch(() => {});
  }, []);

  if (modules.logo_marquee === false || !sponsors.length) return null;

  const open = (s) => {
    api.post(`/sponsors/${s.id}/click`).catch(() => {});
    if (s.url) window.open(s.url.startsWith('http') ? s.url : `https://${s.url}`, '_blank', 'noopener');
    else toast.info(`${s.name || 'Sponsor'} için yönlendirme linki henüz eklenmedi.`);
  };

  const items = [...sponsors, ...sponsors];
  const durationSec = Math.max(22, sponsors.length * 5);

  return (
    <div data-testid="logo-marquee" className="bg-bh-canvas border-b border-white/5 overflow-hidden">
      <div
        className="flex marquee-track whitespace-nowrap py-2.5"
        style={{ animationDuration: `${durationSec}s` }}
      >
        {items.map((s, i) => (
          <button
            key={`${s.id}-${i}`}
            type="button"
            data-testid={`logo-marquee-item-${s.id}`}
            onClick={() => open(s)}
            className="inline-flex items-center gap-2.5 px-7 shrink-0 opacity-75 hover:opacity-100 transition-opacity cursor-pointer"
          >
            <span className="sponsor-logo sponsor-logo--marquee">
              <img src={mediaUrl(s.logo_url || s.logo)} alt={s.name || ''} />
            </span>
            {s.name ? <span className="sponsor-name text-sm text-gray-200">{s.name}</span> : null}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LogoMarquee;
